<template>
  <div class="lawFirm">
    <div class="law_box">
      <div class="advanced_search">
        <el-tabs style="margin: 0">
          <div style="display: flex; position: relative">
            <el-input
              placeholder="请输入检索内容"
              v-model="input"
              class="input-with-select"
              @keyup.enter.native="searchLaw"
              clearable
            >
            </el-input>

            <el-button type="warning" @click="searchLaw" style="width: 80px"
              >检索</el-button
            >
          </div>
          <div style="margin: 10px 0 0 0">
            <el-radio-group v-model="radios">
              <el-radio :label="'1'" @change="accuracy('1')">模糊检索</el-radio>
              <el-radio :label="'2'" @change="accuracy('2')">精准检索</el-radio>
            </el-radio-group>
          </div>
          <div class="conditions">
            <div class="condition">
              <span style="position: absolute">搜索条件</span>
              <span class="eltags">
                <el-tag
                  closable
                  type="warning"
                  v-for="(item, ind) in lawCondition"
                  :key="ind + 'item'"
                  @close="handleClose(item.type, ind)"
                >
                  <span v-if="item.type == 'input'">检索：</span>
                  <span v-if="item.type == 'city'">地区：</span>
                  <span v-if="item.type == 'time'">时间：</span>
                  <span v-if="item.type == 'scale'">规模：</span>
                  <span>{{ item.name }}</span>
                </el-tag>
              </span>
            </div>
            <div class="savebtn">
              <i class="el-icon-delete" @click="remove">清空条件</i>
            </div>
          </div>
        </el-tabs>
      </div>
      <div class="mainstay">
        <div class="left">
          <el-menu
            default-active="2"
            class="el-menu-vertical-demo"
            :default-openeds="openeds"
          >
          <el-submenu index="3">
              <template slot="title">
                <!-- <img
                  src="../../../assets/imgs/2(1).png"
                  alt=""
                  style="width: 30px; margin-right: 10px"
                /> -->
                <span class="imgTitle" style="font-weight: 900; font-size: 18px"
                  >律所规模</span
                >
              </template>
              <div class="sift_tree">
                <el-tree
                  :data="scale"
                  :props="court"
                  v-loading="loadNode"
                  element-loading-text="拼命加载中"
                  element-loading-spinner="el-icon-loading"
                  accordion
                  :expand-on-click-node="false"
                  :default-expand-all="this.scaleall"
                  @node-click="scaleClick"
                  class="region"
                >
                  <span class="custom-tree-node" slot-scope="{ data }">
                    <span
                      style="padding-bottom: 10px !import; line-height: 20px"
                      >{{ data.key }}&emsp;({{ data.doc_count }})</span
                    >
                  </span>
                </el-tree>
                
              </div>
            </el-submenu>
            <el-submenu index="1">
              <template slot="title">
                <!-- <img
                  src="../../../assets/imgs/2(1).png"
                  alt=""
                  style="width: 30px; margin-right: 10px"
                /> -->
                <span class="imgTitle" style="font-weight: 900; font-size: 18px"
                  >地区</span
                >
              </template>
              <div class="sift_tree">
                <el-tree
                  :data="moreall ? courtData : courtData.slice(0, 10)"
                  :props="court"
                  v-loading="loadNode"
                  element-loading-text="拼命加载中"
                  element-loading-spinner="el-icon-loading"
                  accordion
                  :expand-on-click-node="false"
                  @node-click="regionClick"
                  :default-expand-all="this.defaultall"
                  class="region  cityClass"
                >
                  <span class="custom-tree-node" slot-scope="{ data }">
                    <span
                      style="padding-bottom: 10px !import; line-height: 20px"
                      >{{ data.name }}&emsp;({{ data.count }})</span
                    >
                  </span>
                </el-tree>
                <span
                  v-if="courtData.length > 10"
                  @click="more"
                  v-show="moreShow"
                  class="more"
                  style=""
                  >查看更多</span
                >
              </div>
            </el-submenu>
            <el-submenu index="2">
              <template slot="title">
                <!-- <img
                  src="../../../assets/imgs/5(1)(1).png"
                  alt=""
                  style="width: 30px; margin-right: 10px"
                /> -->
                <span class="imgTitle" style="font-weight: 900; font-size: 18px"
                  >成立日期</span
                >
              </template>
              <div class="sift_tree">
                <el-tree
                  v-loading="loadNode"
                  element-loading-text="拼命加载中"
                  element-loading-spinner="el-icon-loading"
                  :data="timeall ? timeData : timeData.slice(0, 10)"
                  :props="time"
                  @node-click="timeClick"
                >
                  <span class="custom-tree-node" slot-scope="{ data }">
                    <span style="line-height: 20px"
                      >{{ data.key_as_string }}&emsp;({{
                        data.doc_count
                      }})</span
                    >
                  </span>
                </el-tree>
                <span
                  class="more"
                  v-if="timeData.length > 10"
                  @click="times"
                  v-show="timeShow"
                  >查看更多</span
                >
              </div>
            </el-submenu>
          </el-menu>
        </div>
        <div class="right">
          <div class="box_right_top">
            <div>
              <span style="margin-right: 20px"
                >共<span style="color: #cf8700">{{ totalCount }}</span
                >所</span
              >
            </div>
            <div>
              <span style="margin: 0 10px">排序方式</span>
              <el-select
                v-model="valuesort"
                placeholder="请选择"
                size="mini"
                style="width: 95px"
              >
                <el-option
                  v-for="item in defaultsort"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                  <span @click="itemsort(item.value)">{{ item.label }}</span>
                </el-option>
              </el-select>
            </div>
          </div>
          <div
            class="box_main"
            v-loading="loadNode"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            style="min-height: 500px"
            element-loading-background="rgba(255, 255, 255, 0.5)"
          >
            <div
              v-if="List_number == 0"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                height: 500px;
              "
            >
              <div>
                <img src="./kongkong.png" alt="" />
                <div style="text-align: center; font-size: 20px">暂无数据</div>
              </div>
            </div>
            <div
              class="box_main_list"
              v-for="(item, index) in lawFirmList"
              :key="index"
            >
              <div class="title">
                <!-- <el-checkbox v-model="check" :value='item.id' @change="handleCheckedCitiesChange"></el-checkbox> -->
                <h2
                  @click="lawDetail(item._id)"
                  style="
                    display: inline-block;
                    font-weight: 900;
                    font-size: 18px;
                  "
                  v-html="item._source.name"
                >
                
                  <!-- {{  }} -->
                </h2>
                <div class="collection" v-if="!item._source.coll">
                    <el-tooltip content="收藏" placement="left" effect="light">
                      <img
                        @click="collectible(item)"
                        src="../../../assets/imgs/2.0/_收藏.png"
                        alt=""
                      />
                    </el-tooltip>
                  </div>
                  <div class="collection" v-if="item._source.coll">
                    <el-tooltip content="收藏" placement="left" effect="light">
                      <img
                        v-if="item._source.coll == 0"
                        @click="collectible(item)"
                        src="../../../assets/imgs/2.0/_收藏.png"
                        alt=""
                      />
                    </el-tooltip>
                    <el-popconfirm
                      title="确认取消收藏吗？"
                      @confirm="cancel(item)"
                    >
                      <img
                        slot="reference"
                        v-if="item._source.coll == 1"
                        src="../../../assets/imgs/2.0/收藏3.png"
                        alt=""
                      />
                    </el-popconfirm>
                  </div>
              </div>
              <!-- <span class="case">指导性案例</span> -->
              <div class="box_detail">
                <div class="logo">
                  <span> {{ item._source.name1 }}</span>
                </div>
                <div class="lawData">
                  <p class="lawCity">
                    
                    <span style="width: 180px"
                      >地区：{{ item._source.city.name }}</span
                    ><span style="width: 180px"
                      >规模大小：<span>{{item._source.scale}}</span>
                      <!-- <span v-if="item._source.nums < 10"
                        >小型律所</span
                      >
                      <span
                        v-if="item._source.nums >= 10 && item._source.nums < 50"
                        >中型律所</span
                      >

                      <span v-if="item._source.nums >= 50">大型律所</span> -->
                    </span>
                    <span>成立日期：{{ item._source.year }}</span>
                  </p>
                  <p class="lawCity" style="margin: 20px 0">
                    <span style="width: 180px"
                      >电话：{{ item._source.tel }}</span
                    ><span style="width: 180px"
                      >律师数量：{{ item._source.nums }}</span
                    ><span>律所代码：{{ item._source.firm_code }}</span>
                  </p>
                  <p>
                    <span>地址：{{ item._source.address }}</span>
                  </p>
                </div>
              </div>
            </div>
            <!-- <div class="page-bar" v-if="all > 1">
              <ul>
                <li v-if="parameter.page > 1">
                  <a v-on:click="parameter.page--, pageClick()">上一页</a>
                </li>
                <li v-if="parameter.page == 1">
                  <a class="banclick">上一页</a>
                </li>
                <li
                  v-for="index in indexs"
                  :key="index"
                  v-bind:class="{ active: parameter.page == index }"
                >
                  <a v-on:click="btnClick(index)">{{ index }}</a>
                </li>
                <li v-if="parameter.page != all">
                  <a v-on:click="pageClick(parameter.page++)">下一页</a>
                </li>
                <li v-if="parameter.page == all">
                  <a class="banclick">下一页</a>
                </li>
                
              </ul>
            </div> -->
            <div class="page-bar">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="totalCount > 10000 ? 10000 : totalCount"
                @current-change="handleCurrentChange"
                :current-page.sync="cur_page"
              >
              </el-pagination>
            </div>
          </div>
        </div>

        <!-- <div class="recommend">
          <h3>热门推荐</h3>
          <div class="suggest">
            <p v-for="(item, index) in recommendList" :key="index">
              <span v-if="index == 0" style="color: #e62b3c; text-align: center"
                >{{ index + 1 }}、</span
              >
              <span v-if="index == 1" style="color: #e26e31; text-align: center"
                >{{ index + 1 }}、</span
              >
              <span v-if="index == 2" style="color: #f4b140; text-align: center"
                >{{ index + 1 }}、</span
              >
              <span v-if="index >= 3" style="text-align: center"
                >{{ index + 1 }}、</span
              >
              <span class="linkRecommend">{{ item }}</span>
            </p>
          </div>
        </div> -->
      </div>
    </div>
    <ComFooter></ComFooter>
  </div>
</template>

<script>
import store from "@/store";
import ComFooter from "../../../components/ComFooter.vue";
export default {
  data() {
    return {
      input: "", //检索框
      radios: "1",
      openeds: ["1", "2","3"],
      lawCondition: [], //检索及筛选条件
      parameter: {
        page: 1,
        pagesize: 10,
        search: "",
        city: "",
        year: "",
        order: "",
        scale:'',
      },
      sort: { field: "", type: "desc" },
      simpleSearch: {
        word: "",
        type: "1",
      },
      courtData: [], //地区筛选数据
      timeData: [], //时间筛选数据
      loadNode: true, //加载框
      court: {
        children: "children",
        label: "name",
      }, //树形控件配置
      moreall: false, //左侧展示长度
      moreShow: true, //是否展示更多
      timeall: false,
      timeShow: true,
      defaultall: false,
      scaleall: false,
      time: {
        children: "children",
        label: "key_as_string",
      },
      lawFirmList: [], //列表展示
      List_number: "",
      recommendList: [
        "盈科律所事务所盈科律所事务所盈科律所事务所盈科律所事务所",
        "盈科律所事务所",
        "盈科律所事务所",
        "盈科律所事务所",
        "盈科律所事务所",
        "盈科律所事务所",
        "盈科律所事务所",
        "盈科律所事务所",
        "盈科律所事务所",
        "盈科律所事务所",
      ],
      totalCount: 0, //律所数量
      all: 0, //总条数
      new: "",
      old: "1",
      or: true,
      cur_page: 1,
      totalCount: 0, //检索结果的数量
      valuesort: "",
      defaultsort: [
        {
          value: "",
          label: "相关度",
        },
        {
          value: "asc",
          label: "时间正序",
        },
        {
          value: "desc",
          label: "时间倒序",
        },
      ],
      scale:[],
    };
  },
  created() {
    // console.log(JSON.parse(window.sessionStorage.getItem("lawSearch")))
    if (window.sessionStorage.getItem("lawSearch")) {
      let retain = JSON.parse(window.sessionStorage.getItem("lawSearch"));
      // console.log(retain)
      this.lawCondition = retain;
      retain.forEach((item) => {
        if (item.type == "input") {
          this.simpleSearch = JSON.parse(this.simpleSearch);
          this.simpleSearch.word = item.name;
        }
        if (item.type == "time") {
          this.parameter.year = item.name;
        }
        if (item.type == "city") {
          this.parameter.city = item.val;
        }
        if (item.type == "scale") {
          this.parameter.scale = item.name;
        }
      });

      // console.log(this.parameter)
    }
    // console.log(this.parameter)
    this.lawList();
  },
  methods: {
    // 获取数据
    lawList() {
      this.$set(this.parameter, "search", JSON.stringify(this.simpleSearch));
      this.parameter.order = JSON.stringify(this.sort);
      this.$http
        .post("/lawfirm", this.parameter)
        .then((res) => {
          console.log(res);
          // if (this.or) {
          //   this.$router.push({
          //     path: "/lawFirm",
          //     query: this.parameter,
          //   });
          // }

          this.courtData = res.data.data.cat.city_district;
          this.timeData = res.data.data.cat.year;
          this.scale = res.data.data.cat.scale;
          this.totalCount = res.data.data.list.total.value;
          
          // this.totalCount =
          if (Math.ceil(this.totalCount / 10) > 1000) {
            this.all = 1000;
          }
          if (Math.ceil(this.totalCount / 10) <= 1000) {
            this.all = Math.ceil(this.totalCount / 10);
          }
          this.lawFirmList = res.data.data.list.hits;
          this.List_number = this.lawFirmList.length;
          this.loadNode = false;
          this.or = true;
        })
        .catch((error) => {
          console.log(error);
        });
      //
    },
    // 检索框
    searchLaw() {
      // this.parameter = {
      //   page: 1,
      //   pagesize: 10,
      //   search: "",
      //   city: "",
      //   year: "",
      // };
      this.simpleSearch.word = this.input;
      this.loadNode = true;
      this.parameter.page = 1;
      this.cur_page = 1;
      this.lawList();
      this.lawCondition = [];
      if (this.input !== "") {
        let search_tag = {
          type: "input",
          name: this.input,
        };
        this.lawCondition.push(search_tag);
        window.sessionStorage.setItem(
          "lawSearch",
          JSON.stringify(this.lawCondition)
        );
      } else {
        window.sessionStorage.removeItem("lawSearch");
      }

      // let or = this.lawCondition.forEach((item) => {
      //   if (item.type == "input") {
      //     return true;
      //   }
      // });
      // if (or) {
      //   this.lawCondition.forEach((item) => {
      //     if (item.type == "input") {
      //       item.name = this.input;
      //     }
      //   });
      // } else {
      //   let search_tag = {
      //     type: "input",
      //     name: this.input,
      //   };
      //   this.lawCondition.push(search_tag);
      // }
    },
    // 查看更多地区
    more() {
      // console.log("aa");
      this.moreall = true;
      this.moreShow = false;
    },
    // 查看更多时间
    times() {
      this.timeall = true;
      this.timeShow = false;
    },
    // 模糊  / 精确  检索
    accuracy(type) {
      // console.log(type);
      this.simpleSearch.type = type;
    },
    // 删除检索 / 筛选 条件
    handleClose(type, index) {
      this.lawCondition.splice(index, 1);
      window.sessionStorage.setItem(
        "lawSearch",
        JSON.stringify(this.lawCondition)
      );
      if (this.lawCondition.length == 0) {
        this.parameter = {
          page: 1,
          pagesize: 10,
          search: "",
          city: "",
          year: "",
        };
        this.simpleSearch = {
          word: "",
          type: this.radios,
        };
      } else if (type == "city") {
        this.parameter.city = "";
      } else if (type == "time") {
        this.parameter.year = "";
      } else if (type == "scale") {
        this.parameter.scale = "";
      }else {
        this.simpleSearch = {
          word: "",
          type: this.radios,
        };
      }
      this.loadNode = true;
      this.parameter.page = 1;
      this.cur_page = 1;
      this.lawList();
    },
    // 清空检索条件
    remove() {
      this.lawCondition = [];
      window.sessionStorage.removeItem("lawSearch");
      this.parameter = {
        page: 1,
        pagesize: 10,
        search: "",
        city: "",
        year: "",
      };
      this.simpleSearch = {
        word: "",
        type: this.radios,
      };
      this.loadNode = true;
      this.parameter.page = 1;
      this.cur_page = 1;
      this.lawList();
    },
    // 筛选规模
    scaleClick(data) {
      console.log(data);
      // return
      this.parameter.scale = data.key;
      let or = this.lawCondition.some(function (item) {
        if (item.type == "scale") {
          return true; //返回false
        }
      });
      if (or) {
        this.lawCondition.forEach((item) => {
          if (item.type == "scale") {
            item.name = data.key;
          }
        });
      } else {
        let scale_tag = {
          type: "scale",
          name: data.key,
        };
        this.lawCondition.push(scale_tag);
      }
      window.sessionStorage.setItem(
        "lawSearch",
        JSON.stringify(this.lawCondition)
      );
      this.parameter.page = 1;
      this.cur_page = 1;
      this.loadNode = true;
      this.lawList();
    },
    // 选中地区
    regionClick(data) {
      console.log(data);
      this.defaultall = true;
      this.parameter.city = data.val;
      let or = this.lawCondition.some(function (item) {
        if (item.type == "city") {
          //item.name == "小百里守约"
          return true; //返回false
        }
      });
      // console.log(or);
      if (or) {
        this.lawCondition.forEach((item) => {
          if (item.type == "city") {
            item.val = data.val;
            item.name = data.name;
          }
        });
      } else {
        let city_tag = {
          type: "city",
          val: data.val,
          name: data.name,
        };
        this.lawCondition.push(city_tag);
      }
      window.sessionStorage.setItem(
        "lawSearch",
        JSON.stringify(this.lawCondition)
      );
      this.parameter.page = 1;
      this.cur_page = 1;
      this.loadNode = true;

      this.lawList();
    },
    // 筛选成立日期
    timeClick(data) {
      // console.log(data);
      this.parameter.year = data.key_as_string;
      let or = this.lawCondition.some(function (item) {
        if (item.type == "time") {
          return true; //返回false
        }
      });
      if (or) {
        this.lawCondition.forEach((item) => {
          if (item.type == "time") {
            item.name = data.key_as_string;
          }
        });
      } else {
        let year_tag = {
          type: "time",
          name: data.key_as_string,
        };
        this.lawCondition.push(year_tag);
      }
      window.sessionStorage.setItem(
        "lawSearch",
        JSON.stringify(this.lawCondition)
      );
      this.parameter.page = 1;
      this.cur_page = 1;
      this.loadNode = true;
      this.lawList();
    },
    // 排序方式
    itemsort(a) {
      // console.log(this.valuesort);
      // console.log(a);
      this.sort.type = a;
      if(a == ''){
        this.sort.field = '';
      }else{
        this.sort.field = 'year';
      }
      this.parameter.page = 1;
      this.cur_page = 1;
      this.loadNode = true;
      this.lawList();
      
    },
    collectible(it) {
      console.log(it);
      if (window.localStorage.getItem("userType") == "ipuser") {
        let collOne = {
          // user_id: store.getCookie("user_id"),
          docid: it._id,
          // role: store.getCookie("role"),
          doctype: 2,
          docname: it._source.name1,
        };
        this.$http
          .post("/coll", collOne)
          .then((res) => {
            console.log(res);
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.lawList();
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$message({
          message: "请登录个人账号！！",
          type: "warning",
        });
      }
    },
    cancel(it) {
      // console.log("a");
      if (window.localStorage.getItem("userType") == "ipuser") {
        let collOne = {
          docid: it._id,
        };
        this.$http
          .post("/delcoll", collOne)
          .then((res) => {
            console.log(res);
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.lawList();
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$message({
          message: "请登录个人账号！！",
          type: "warning",
        });
      }
    },
    // 律所详情页
    lawDetail(id) {
      let newUrl = this.$router.resolve({
        path: "/lawsDetail",
        query: { id: id, page: 1, pagesize: 5 },
      });
      // console.log(newUrl)
      window.open(newUrl.href, "_blank");
    },
    // 分页
    pageClick() {
      // console.log("现在在" + this.cur + "页");
      // window.scrollTo(0, 0);
      this.$set(this.parameter, "search", JSON.stringify(this.simpleSearch));
      this.$router.push({
        path: "/lawFirm",
        query: this.parameter,
      });
      // this.or = false;
      // this.lawList();
      // this.$router.push({
      //       name: "Case",
      //       query: { page: 1 ,pageSize:10},
      //     });
    },
    btnClick(data) {
      //页码点击事件
      // console.log(data);

      if (data != this.parameter.page) {
        this.parameter.page = data;
      }
      this.$set(this.parameter, "search", JSON.stringify(this.simpleSearch));
      this.$router.push({
        path: "/lawFirm",
        query: this.parameter,
      });
      // this.currentPage = this.cur;
      // window.scrollTo(0, 0);
      // this.or = false;
      // // this.loadNode = true;
      // // this.loading_box = true;
      // this.lawList();
    },
    handleCurrentChange(val) {
      // console.log(typeof val)
      this.parameter.page = val;
      this.cur_page = val;
      // this.$set(this.parameter, "search", JSON.stringify(this.simpleSearch));
      // this.$router.push({
      //   path: "/lawFirm",
      //   query: this.parameter,
      // });
      this.loadNode = true;
      window.scrollTo(0, 0);
      this.lawList();
    },
  },
  watch: {
    // 监听接口参数对象变化
    parameter: {
      handler(new_value) {
        // console.log(new_value);
      },
      deep: true,
    },
    // 监听路由变化
    "$route.query"(newval, oldval) {
      // console.log(newval, oldval);
      // this.new = JSON.stringify(newval);
      // this.old = JSON.stringify(oldval);
      // let jump = [];
      // if (
      //   JSON.stringify(newval) !== JSON.stringify(oldval) &&
      //   JSON.stringify(oldval) !== "{}"
      // ) {
      //   if (newval.city !== "") {
      //     let reg = /[0-9]+/g;
      //     let nameNoun = newval.city.replace(reg, "");
      //     let cities = {
      //       type: "city",
      //       val: newval.city,
      //       name: nameNoun,
      //     };
      //     jump.push(cities);
      //   } else {
      //     this.parameter.city = "";
      //   }
      //   if (newval.year !== "") {
      //     let times = {
      //       type: "time",
      //       name: newval.year,
      //     };
      //     jump.push(times);
      //   } else {
      //     this.parameter.year = "";
      //   }
      //   if (JSON.parse(newval.search).word !== "") {
      //     let searches = {
      //       type: "input",
      //       name: JSON.parse(newval.search).word,
      //     };
      //     jump.push(searches);
      //   } else {
      //     this.simpleSearch.word = "";
      //   }
      //   this.radios = JSON.parse(newval.search).type;
      //   // console.log(jump);
      //   this.lawCondition = jump;
      //   window.sessionStorage.setItem(
      //     "lawSearch",
      //     JSON.stringify(this.lawCondition)
      //   );
      //   if (newval.page !== oldval.page) {
      //     this.parameter.page = newval.page;
      //     this.cur_page = Number(newval.page);
      //     // console.log(typeof newval.page)
      //   }
      //   this.or = false;
      //   this.lawList();
      // }
    },
  },
  computed: {
    indexs: function () {
      var left = 1;
      var right = this.all;
      var ar = [];
      if (this.all >= 10) {
        if (this.parameter.page > 6 && this.parameter.page < this.all - 2) {
          left = this.parameter.page - 6;
          right = this.parameter.page + 3;
        } else {
          if (this.parameter.page <= 6) {
            left = 1;
            right = 10;
          } else {
            right = this.all;
            left = this.all - 4;
          }
        }
      }
      while (left <= right) {
        ar.push(left);
        left++;
      }
      return ar;
    },
  },
  components: {
    ComFooter,
  },
};
</script>

<style  lang="less" scoped>
.lawFirm {
  width: 100%;
  background: url("../../../assets/imgs/raphael-schaller-GkinCd2enIY-unsplash.png");
  background-size: 100% 1000px;
  background-repeat: no-repeat;
  // max-width: 1920px;
  margin: auto;
  .law_box {
    width: 1280px;
    min-width: 1280px;
    max-width: 1280px;
    margin: auto;
    min-height: calc(100vh - 60px);
    .advanced_search {
      // margin-left: ;
      margin-left: 20%;
      display: flex;
      .carousel {
        padding: 20px 20px 20px 10px;
        border-radius: 10px;
        width: 20%;
        height: 150px;
        /deep/ .el-carousel__button {
          width: 10px;
        }
        .el-carousel__item h3 {
          display: inline-block;
          height: 120px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #475669;
          font-size: 14px;
          opacity: 0.75;
          // line-height: 50px;
          margin: 0;
          span {
            display: inline-block;
          }
        }

        .el-carousel__item:nth-child(2n) {
          // background-color: #99a9bf;
          background-image: url("../../../assets/imgs/背景图/raphael-schaller-GkinCd2enIY-unsplash.png");
          background-size: 100% 100%;
        }

        .el-carousel__item:nth-child(2n + 1) {
          // background-image: url('../../../assets/imgs/背景图/9760eac49571416.jpg');
          background-image: url("../../../assets/imgs/背景图/raphael-schaller-GkinCd2enIY-unsplash.png");
          background-size: 100% 100%;
        }
      }
      .el-tabs {
        width: 79%;
        .el-tab-pane {
          .el-popover {
          }
          .el-input {
            // height: 20px;
            /deep/ .el-input__inner {
              // border-radius: 0;
            }
          }
          .el-button {
            margin: 0;
            border: 0;
            // border-radius: 0;
          }
        }
      }
      /deep/ .el-popover--plain {
        margin-left: 700px;
      }
    }
    .conditions {
      display: flex;
      // height: 32px;
      line-height: 32px;
      justify-content: space-between;
      margin: 10px 0;
      .condition {
        position: relative;
        span {
          // display: block;
        }
        // overflow: hidden;
        .eltags {
          display: inline-block;
          max-width: 610px;
          margin-left: 60px;
        }
        .el-tag {
          margin: 0 0 5px 5px;
        }
      }
      .savebtn :hover {
        color: #409eff;
        cursor: pointer;
      }
    }
  }
}
.mainstay {
  display: flex;
  .left {
    width: 19%;
    max-width: 20%;
    padding: 0 10px 10px 10px;
    margin-right: 1%;

    border-radius: 5px;
    // height: 100vh;
    // min-height: 1000px;
    // max-height: 3000px;
    // background: white;

    margin-bottom: 2%;
    .el-menu {
      padding: 0 0px 0px 10px;
      background: white;
      border: none;
      border-radius: 10px;
    }
    h2 {
      margin: 10px 0;
      // font-size: 18px;
      font-weight: 600;
      span {
        font-size: 28px;
        color: chocolate;
        font-weight: 600;
      }
    }
  }
  .right {
    // width: 63%;
    width: 80%;
    .box_right_top {
      padding: 10px;
      // background: white;
      border-radius: 5px;
      display: flex;
      justify-content: space-between;
    }
    .box_main {
      // margin-top: 20px;

      .box_main_list {
        margin: 0px 0 20px 0px;
        // height: 200px;
        // height: 300px;
        border-radius: 5px;
        padding: 10px;
        background: #f8f7f6;
        .title {
          display: flex;
          justify-content: space-between;
          // margin-bottom: 10px;
          line-height: 28px;
          cursor: pointer;
          h2 {
            font-size: 16px;
            font-weight: 600;
          }
        }
        .title :hover {
          // color: rgb(197, 197, 197);
           color: #cf8700;
        }

        .box_detail {
          margin-top: 10px;
          // height: 200px;
          background: #ffffff;
          padding: 18px;
          display: flex;
          // justify-content: space-between;
          .lawData {
            margin: 0 20px;
            .lawCity {
              span {
                display: inline-block;
              }
            }
          }
          .logo {
            width: 120px;
            min-height: 82px;
            padding: 10px 0;
            background: #8ca3cd;
            color: #fff;
            border-radius: 5px;
            display: flex;
            justify-content: center;
            align-items: center;
            span {
              margin: 0 20px;
              line-height: 20px;
              display: inline-block;
              text-align: center;
              font-size: 16px;
              font-weight: 600;
              font-family: "SF Pro Text", "Helvetica Neue", Helvetica, Tahoma,
                Arial, "Microsoft Yahei", "微软雅黑", "PingFang SC", "苹方",
                sans-serif;
            }
          }
        }
      }
    }
  }
  .recommend {
    width: 16%;
    margin-left: 1%;
    height: 450px;
    background: white;
    border-radius: 5px;
    padding: 10px;
    h3 {
      // line-height: 30px;
      // padding: 20px;
    }
    .suggest {
      margin: 10px 0;
      p {
        line-height: 30px;
        span {
          min-width: 30px;
          max-width: 150px;
          display: inline-block;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        .linkRecommend:hover {
          color: rgb(109, 109, 109);
          cursor: pointer;
          font-size: 16px;
        }
      }
    }
  }
}
.sift_tree::-webkit-scrollbar {
  display: none;
}
.sift_tree {
  max-height: 450px;
  overflow-x: hidden;
  // overflow-y: scroll;
}
// 查看更多 样式
.more {
  cursor: pointer;
  color: #409eff;
  height: 30px;
  width: 100%;
  display: inline-block;
  display: flex;
  justify-content: center;
  align-items: center;
}
.page-bar {
  margin-bottom: 20px;
  // width: ;
  height: 50px;
  line-height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  ul {
    display: inline-block;
    width: 550px;
  }
}
// ul,li{
//     margin: 0px;
//     padding: 0px;
// }
li {
  list-style: none;
}
.page-bar li:first-child > a {
  margin-left: 0px;
}
.page-bar a {
  border: 1px solid #ddd;
  text-decoration: none;
  position: relative;
  float: left;
  padding: 6px 12px;
  margin-left: -1px;
  line-height: 1.42857143;
  color: #337ab7;
  cursor: pointer;
}
.page-bar a:hover {
  background-color: #eee;
}
.page-bar a.banclick {
  cursor: not-allowed;
}
.page-bar .active a {
  color: #fff;
  cursor: default;
  background-color: #337ab7;
  border-color: #337ab7;
}
.page-bar i {
  font-style: normal;
  color: #d44950;
  margin: 0px 4px;
  font-size: 12px;
}
.imgTitle {
  position: relative;
  left: -20px;
}
/deep/ .el-tree-node__content {
  // margin: 5px 15px 5px 0;
  // min-height: 40px;
}
.region {
  /deep/ .el-tree-node {
    white-space: normal;
    // padding: 10px 0;
    // max-width: 170px;
    // line-height: 25px;
    // text-align: center;
    
      .el-tree-node__content {
        height: 100%;
        align-items: start;
        line-height: 30px;
      }
    // .el-tree-node__content {
    //   height: 100%;
    //   align-items: start;
    // }
  }
}
.cityClass {
  /deep/ .el-tree-node__content {
    // height: 60px;
    // max-height: 60px !important;
    // display: inline-block;
    // margin: 5px 5px 5px 0;
    
    
  }
  /deep/ .custom-tree-node{
      // display: inline;
      padding-right: 10px;
    }
  /deep/ .custom-tree-node {
    // margin: 10px 0;
    // padding-right: 10px;
    // width: 150px;

    // display: inline-block;
    // max-height: 50px;
  }
}
.collection {
  img {
    width: 28px;
  }
}
.collection:hover img {
  cursor: pointer;
  // content: url("../../../assets/imgs/2.0/收藏3.png");
}
/deep/ .el-tree-node__expand-icon{
  position: relative;
  top: 3px;
}
</style>